import { Injectable, Inject } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ListNameModel, SurveyQuestion } from "../models/survey-question.model";
import { Employee } from "../models/employee.model";
import { Verification } from "../models/verification.model";
import { Observable, of } from "rxjs";
import { SaveSurveyEntry } from "../models/save-survey-entry.model";
import { ScreeningReport } from "../models/screening-report.model";
import { SurveyInfo } from "../models/surveyinfo.model";
import { tap } from "rxjs/operators";
import { UsageReport } from "../models/usage-report.model";
import { SurveyResponse } from "../models/survey-response.model";
import { LastSurveyTakenInput } from "../models/last-survey-taken-input.model";
import { PeopleDto } from "../models/people.model";
import { TestStatus } from "../models/teststatus.model";
import { SurveyQuestionVm } from './../models/surveyquestionVm';

@Injectable({
  providedIn: "root",
})
export class SurveyService {
  public showRedirectTimer = false;
  private surveryInfoList: SurveyInfo[];

  public locationOrEvent: {
    location: string,
    event:string
  }

  constructor(
    private http: HttpClient,
    @Inject("BASE_URL") private baseUrl: string
  ) {
    this.locationOrEvent = {event:'', location:''};
  }

  getApiVersion() {
    return this.http.get<any>(this.baseUrl + "api/survey/version");
  }

  getSurveyInfos(): Observable<SurveyInfo[]> {
    if (this.surveryInfoList) {
      return of(this.surveryInfoList);
    }

    return this.http
      .get<SurveyInfo[]>(this.baseUrl + "api/survey/list")
      .pipe(tap((data) => console.log(data)));
  }

  getSurveyQuestions(surveyAppID: number) {
    //return SURVEYQUESTIONS.filter(q=>q.surveyAppID == surveyAppID);
    return this.http.get<SurveyQuestion[]>(
      this.baseUrl + "api/survey/" + surveyAppID
    );
  }
  
  getExemptionRequestSubmissionQuestions() {
    //return SURVEYQUESTIONS.filter(q=>q.surveyAppID == surveyAppID);
    return this.http.get<SurveyQuestionVm[]>(
      this.baseUrl + "api/survey/exception-request-submission-questions"
    );
  }

  getEmployeeReturnToWorkQuestions() {
    //return SURVEYQUESTIONS.filter(q=>q.surveyAppID == surveyAppID);
    return this.http.get<SurveyQuestionVm[]>(
      this.baseUrl + "api/survey/rtw-questions"
    );
  }

  GetSparkySurveyFormQuestions() {
    //return SURVEYQUESTIONS.filter(q=>q.surveyAppID == surveyAppID);
    return this.http.get<SurveyQuestionVm[]>(
      this.baseUrl + "api/survey/sparky-questions"
    );
  }

  getReturnToWorkAcknowledgementQuestions() {
    //return SURVEYQUESTIONS.filter(q=>q.surveyAppID == surveyAppID);
    return this.http.get<SurveyQuestionVm[]>(
      this.baseUrl + "api/survey/rtw-acknowledgement-questions"
    );
  }



  getCovidReturnToWorkQuestions() {
    //return SURVEYQUESTIONS.filter(q=>q.surveyAppID == surveyAppID);
    return this.http.get<SurveyQuestionVm[]>(
      this.baseUrl + "api/survey/covid-return-to-work-questions"
    );
  }
  rtwNegativeTestQuestions() {
    //return SURVEYQUESTIONS.filter(q=>q.surveyAppID == surveyAppID);
    return this.http.get<SurveyQuestionVm[]>(
      this.baseUrl + "api/survey/covid-rtw-negative-test-questions"
    );
  }

  GetExceptionSecondaryRevReqFormQuestions() {
    //return SURVEYQUESTIONS.filter(q=>q.surveyAppID == surveyAppID);
    return this.http.get<SurveyQuestionVm[]>(
      this.baseUrl + "api/survey/exception-secondary-review-request-questions"
    );
  }

  verifyEmployee(verification: Verification): Observable<Employee> {
    return this.http.post<Employee>(
      this.baseUrl + "api/staff/validate",
      verification
    );
  }

  saveSurveyQuestionsAnswer(saveEntryData: SaveSurveyEntry) {
    return this.http.post<SaveSurveyEntry>(
      this.baseUrl + "api/survey/",
      saveEntryData
    );
  }

  saveSurvey(saveEntryData: SaveSurveyEntry) {
    return this.http.post<number>(
      this.baseUrl + "api/survey/save-survey",
      saveEntryData
    );
  }


  savePreshiftQuestionsAnswer(saveEntryData: SaveSurveyEntry) {
    return this.http.post<SaveSurveyEntry>(
      this.baseUrl + "api/survey/pre-shift",
      saveEntryData
    );
  }

  saveCovidExposureQuestionsAnswer(saveEntryData: SaveSurveyEntry) {
    return this.http.post<SaveSurveyEntry>(
      this.baseUrl + "api/covidexposure/save-entry",
      saveEntryData
    );
  }

  saveMonkeypoxQuestionsAnswer(saveEntryData: SaveSurveyEntry) {
    return this.http.post<SaveSurveyEntry>(
      this.baseUrl + "api/monkeypox/save-entry",
      saveEntryData
    );
  }


  verifyRecaptcha(recaptchResponse: string) {
    let payload = { response: recaptchResponse };
    return this.http.post(
      this.baseUrl + "api/staff/validate/recaptcha",
      payload
    );
  }

  getScreeningReport(corpId: string) {
    //return SURVEYQUESTIONS.filter(q=>q.surveyAppID == surveyAppID);
    let headers = new HttpHeaders({
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Expires: "Sat, 01 Jan 2000 00:00:00 GMT",
    });
    return this.http.get<ScreeningReport>(
      this.baseUrl + "api/survey/report/" + corpId,
      { headers }
    );
  }

  getExposureReport(corpId: string) {
    //return SURVEYQUESTIONS.filter(q=>q.surveyAppID == surveyAppID);
    let headers = new HttpHeaders({
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Expires: "Sat, 01 Jan 2000 00:00:00 GMT",
    });
    return this.http.get<ScreeningReport>(
      this.baseUrl + "api/covidexposure/report/" + corpId,
      { headers }
    );
  }

  getMonkeypoxReport(corpId: string) {
    //return SURVEYQUESTIONS.filter(q=>q.surveyAppID == surveyAppID);
    let headers = new HttpHeaders({
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Expires: "Sat, 01 Jan 2000 00:00:00 GMT",
    });
    return this.http.get<ScreeningReport>(
      this.baseUrl + "api/monkeypox/report/" + corpId,
      { headers }
    );
  }

  getExposureReportedInLast7Days(corpId: string) {
    //return SURVEYQUESTIONS.filter(q=>q.surveyAppID == surveyAppID);
    let headers = new HttpHeaders({
      "Cache-Control": "no-cache",
      Pragma: "no-cache",
      Expires: "Sat, 01 Jan 2000 00:00:00 GMT",
    });
    return this.http.get<ScreeningReport>(
      this.baseUrl + "api/covidexposure/exposure-last7-days/" + corpId,
      { headers }
    );
  }

  getUsageReport(): Observable<UsageReport[]> {
    return this.http
      .get<UsageReport[]>(this.baseUrl + "api/survey/usage")
      .pipe(tap((data) => console.log(data)));
  }

  getLastSurveyResponse(
    surveyAppId: number,
    value: any,
    questionFieldName: string
  ) {
    let input: LastSurveyTakenInput = {
      surveyAppId: surveyAppId,
      questionFieldName: questionFieldName,
      questionAnswer: value,
    };
    return this.http.post<SurveyResponse[]>(
      this.baseUrl + "api/survey/last-taken",
      input
    );
  }

  isTeamMemberVaccinated(corpId: string):Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + "api/survey/vaccinated/"+corpId);
  }

  getVaxDetails(corpId: string):Observable<any> {
    return this.http.get<any>(this.baseUrl + "api/survey/vax-details/"+corpId);
  }

  getComplianceStatus(corpId: string):Observable<any> {
    return this.http.get<any>(this.baseUrl + "api/survey/compliance-status/"+corpId);
  }

  getTestStatus(corpId: string):Observable<TestStatus> {
    return this.http.get<any>(this.baseUrl + "api/survey/test-status/"+corpId);
  }

  getPeople(filter: string): Observable<PeopleDto[]> {
    console.log('calling getpeople: ',filter);
    return this.http.get<PeopleDto[]>(
      this.baseUrl + "api/survey/people-search/" + filter
    );
  }

  getCovidTestOptions(): Observable<ListNameModel[]> {
    return this.http.get<ListNameModel[]>(
      this.baseUrl + "api/survey/covid-test-options"
    );
  }

  getGroups() {
    return this.http.get<any[]>(
      this.baseUrl + "api/survey/groups"
    );
  }

  getMarkets(groupId: number) {
    return this.http.get<any[]>(
      this.baseUrl + "api/survey/markets/" + groupId
    );
  }

  getLocations(groupName: string, marketCode: string) {
    return this.http.get<any[]>(
      `${this.baseUrl}api/survey/locations/${groupName}/${marketCode}`
    );
  }

  getCovidTestAmendedExpDate(testBrand: string, expirationDate: string): Observable<Date> {
    return this.http.get<Date>(this.baseUrl + "api/survey/amendedExpDate/" + testBrand + "/" + expirationDate);
  }

  getExposureDetails(corpId: string) {
    //return of({isFirstAgTest: false, isTMBoostedMoreThan14Days: false, isTMVaccinated: true, isTMValidated: false, isTMContractor: true});
    return this.http.get<any>(this.baseUrl + "api/covidexposure/status-details/"+corpId);
  }

  getEvent(eventName: string) {
    //return of({isFirstAgTest: false, isTMBoostedMoreThan14Days: false, isTMVaccinated: true, isTMValidated: false, isTMContractor: true});
    return this.http.get<any>(this.baseUrl + "api/event/"+eventName);
  }

  async getEventDetails(eventName: string) {
    return await this.http.get<any>(this.baseUrl + "api/event/GetEventDetails/" + eventName);
  }

  async getEventDisplayName(corpId: string) {
    //return of({isFirstAgTest: false, isTMBoostedMoreThan14Days: false, isTMVaccinated: true, isTMValidated: false, isTMContractor: true});
    return await this.http.get<any>(this.baseUrl + "api/event/GetEventDisplayName/"+corpId);
  }
}
